<template>
  <!-- 配方头部 -->
  <div class="containerPaddingBlock">
    <img :src="formulaImg" class="formulaImg" />
    <h3 class="fb boxPadding mb20">配方名称：<span>{{details.formulaName}}</span></h3>
    <div class="boxPadding">
      <span class="mr40">创建人：{{details.createUserName}}</span>
      <span class="mr40">创建时间：{{details.createTime}}</span>
      <span class="mr40">维护周期：{{maintainDate}}</span>
    </div>
    <div class="priceBox">
      <div class="priceBoxTextStyle">
        <p>状态</p>
        <h3>{{details.formulaSolutionType == 1 ? '最优解' : '待优化'}}</h3>
      </div>
      <div class="priceBoxTextStyle">
        <p>日粮价格(元/吨)</p>
        <h3>￥{{details.mixPrice || 0}}</h3>
      </div>
      <div class="priceBoxTextStyle">
        <p>补充料价格(元/吨)</p>
        <h3>￥{{details.price || 0}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import formulaImg from '@/assets/images/formulaImg.png'
export default {
  props: ['details'],
  data(){
    return{
      formulaImg
    }
  },
  computed: {
    maintainDate(){
      return `${this.details.createTime} - ${this.details.updateTime}`
    },
  }
}
</script>

<style lang="scss" scoped>
.fb{
  font-weight: bold;
}
.boxPadding{
  padding-left: 40px;
}
.mr40{
  margin-right: 40px;
}
.mb20{
  margin-bottom: 20px;
}
</style>